module.exports = __webpack_public_path__ + "img/Home-anli-1.9891c3da.png";